module.exports = __webpack_public_path__ + "images/emoji/helicopter.b0727c911d5d30b7379b.png";